import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { SwarmState } from "@/types/swarm";

import { Swarm } from "../../pages/Swarm/schema/swarm";
import { swarmApi } from "./swarm.api";

const initialState: SwarmState = {
	swarms: {
		data: [],
		meta: {
			page: 1,
			limit: 15,
			itemCount: 15,
			pageCount: 1,
			hasPreviousPage: false,
			hasNextPage: false,
		},
	},
};

export const swarmSlice = createSlice({
	name: "swarm",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			swarmApi.endpoints.createSwarm.matchFulfilled,
			(state, { payload }: PayloadAction<Swarm>) => {
				if (payload && state.swarms?.data) {
					state.swarms.data.push(payload);
				}
			}
		);
	},
});

export const swarmReducer = swarmSlice.reducer;
export const swarmSelector = (state: RootState) => state[swarmSlice.name];
